import { IonButton, IonContent } from "@ionic/react";
interface Props {
  setShowModal1: Function;
}
const TripodStand: React.FC<Props> = ({ setShowModal1 }) => {
  return (
    <IonContent placeholder={undefined}>
      <div className="assessment-tape-wrap">
        <div className="icon">
          <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="27"
              cy="27"
              r="25.5"
              fill="#F1F6FE"
              stroke="#31344E"
              strokeWidth="3"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.3433 13C16.6014 13 16 13.6014 16 14.3433V19.1632C16 21.8529 18.1804 24.0333 20.87 24.0333H25.2756L17.3158 40.0589C16.9858 40.7233 17.2569 41.5294 17.9213 41.8595C18.5857 42.1895 19.3919 41.9184 19.7219 41.254L26.2277 28.1555V38.0701C26.2277 38.812 26.8291 39.4134 27.571 39.4134C28.3128 39.4134 28.9142 38.812 28.9142 38.0701V28.1556L35.42 41.254C35.75 41.9184 36.5562 42.1895 37.2206 41.8595C37.885 41.5294 38.1561 40.7233 37.8261 40.0589L29.8663 24.0333H34.0367C36.7264 24.0333 38.9068 21.8529 38.9068 19.1632V14.3433C38.9068 13.6014 38.3054 13 37.5635 13C36.8217 13 36.2203 13.6014 36.2203 14.3433V19.1632C36.2203 20.3691 35.2427 21.3467 34.0367 21.3467H20.87C19.6641 21.3467 18.6865 20.3691 18.6865 19.1632V14.3433C18.6865 13.6014 18.0851 13 17.3433 13Z"
              fill="#31344E"
            />
          </svg>
        </div>
        <h1>TRIPOD / STAND</h1>
        <p>
        Using a tripod will raise your device to the required height of 3 ft. from the ground.
        </p>
        <IonButton
          className="generic-btn"
          onClick={() => setShowModal1(false)} placeholder={undefined}        >
          Close
        </IonButton>
      </div>
    </IonContent>
  );
};
export default TripodStand;
